import React from "react";
import { Switch } from "@headlessui/react";
import cx from "classnames";

export default ({ label = "", description = "", enabled, setEnabled }) => {
    return (
        <Switch.Group
            as={"div"}
            className={"flex items-center justify-between"}
        >
            <span className={"flex flex-grow flex-col"}>
                <Switch.Label
                    as={"span"}
                    className={"text-sm font-medium text-gray-900"}
                    passive
                >
                    {label}
                </Switch.Label>
                <Switch.Description
                    as={"span"}
                    className={"text-sm text-gray-500"}
                >
                    {description}
                </Switch.Description>
            </span>
            <Switch
                checked={enabled}
                onChange={setEnabled}
                className={cx(
                    "relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
                    {
                        "bg-indigo-600": enabled,
                        "bg-gray-200": !enabled,
                    }
                )}
            >
                <span
                    aria-hidden={true}
                    className={cx(
                        "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out",
                        {
                            "translate-x-5": enabled,
                            "translate-x-0": !enabled,
                        }
                    )}
                />
            </Switch>
        </Switch.Group>
    );
};
